<template>
  <div>

    <!-- Formulario -->
    <CustomFieldsFormComponent />

    <br />

    <!-- Historial -->
    <CustomFieldsListComponent />

  </div>
</template>

<script>

// Importaciones
import { mapActions } from "vuex";

// Componentes
import CustomFieldsFormComponent from './Form.vue'
import CustomFieldsListComponent from './List.vue'

export default {
  name: "CustomFieldsComponent",
  data() {
    return {

    }
  },
  components: {
    CustomFieldsFormComponent,
    CustomFieldsListComponent
  },
  async created() {
    await this.getEmergencyResponseGuides();
  },
  methods: {
    // Acciones para el modulo del Naciones unidas - gre administración
    ...mapActions("NuGreAdmin", ['getEmergencyResponseGuides']),
  }
};
</script>

<style scoped>
.text-table {
  font-size: 9pt;
  font-weight: 500;
}
</style>
